export function isStorageAvailable(): boolean {
  try {
    return typeof localStorage === 'object' && navigator.cookieEnabled;
  } catch {
    return false;
  }
}

export const isServer = typeof window === 'undefined';
